import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import toast from "react-hot-toast";
import { InputField } from "../../../formElements/InputField";
import { ComboboxField3 } from "../../../formElements/ComboboxField";
import DataTable from "react-data-table-component";
import { TableStatusField } from "../../../formElements/TableStatusField";
import ItemService from "../../../../services/supplier_appCommonService";
import { checkTimeDifference } from "../../../../common/Validations";
import CreateRFQSuppliers from "./CreateRFQSuppliers";

const CreateRoundModal = ({ show, onHide, rfxNr, supplierList = [], currentRoundNo = 1, onSuccess }) => {
  const [formInputs, setFormInputs] = useState({
    rfxType: "",
  });

  const [getOpenCloseInput, setOpenCloseInput] = useState({
    openingDate: "",
    openingTime: "",
    closingDate: "",
    closingTime: "",
    totalHour: "",
    status: false,
    msg: "",
  });

  const [suppliers, setSuppliers] = useState([]);
  const [selectedSuppliers, setSelectedSuppliers] = useState([]);
  const [getRFxType, setRFxType] = useState([]);
  const [supplierModalShow, setSupplierModalShow] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Previous round quotation comparison
  const [previousRoundQuotes, setPreviousRoundQuotes] = useState([]);
  const [loadingComparison, setLoadingComparison] = useState(false);

  // Line items with buyer counter offer
  const [lineItems, setLineItems] = useState([]);

  // formCOMM / formTECH carried from previous version
  const [formCOMM, setFormCOMM] = useState([]);
  const [formTECH, setFormTECH] = useState([]);

  // Questionnaire form helpers
  const questionTypeOptions = [
    { id: 1, name: "text" },
    { id: 2, name: "number" },
    { id: 3, name: "textarea" },
    { id: 4, name: "select" },
    { id: 5, name: "radio" },
    { id: 6, name: "checkbox" },
  ];

  const handleAddQuestion = (formType) => {
    const newQuestion = {
      componentId: `q_${Date.now()}`,
      serialNo: formType === "formCOMM" ? formCOMM.length + 1 : formTECH.length + 1,
      mandatory: false,
      question: { label: "" },
      answerDefinition: { type: "text", options: [] },
    };
    if (formType === "formCOMM") {
      setFormCOMM((prev) => [...prev, newQuestion]);
    } else {
      setFormTECH((prev) => [...prev, newQuestion]);
    }
  };

  const handleRemoveQuestion = (formType, index) => {
    if (formType === "formCOMM") {
      setFormCOMM((prev) => prev.filter((_, i) => i !== index).map((q, i) => ({ ...q, serialNo: i + 1 })));
    } else {
      setFormTECH((prev) => prev.filter((_, i) => i !== index).map((q, i) => ({ ...q, serialNo: i + 1 })));
    }
  };

  const handleQuestionChange = (formType, index, field, value) => {
    const setter = formType === "formCOMM" ? setFormCOMM : setFormTECH;
    setter((prev) =>
      prev.map((q, i) => {
        if (i !== index) return q;
        if (field === "label") {
          return { ...q, question: { ...q.question, label: value } };
        }
        if (field === "type") {
          return { ...q, answerDefinition: { ...q.answerDefinition, type: value } };
        }
        if (field === "mandatory") {
          return { ...q, mandatory: value };
        }
        return q;
      })
    );
  };

  const renderQuestionnaireEditor = (questions, formType) => (
    <div className="accordion-body">
      <div className="d-flex justify-content-end mb-3">
        <button
          className="btn btn-sm"
          style={{ backgroundColor: "#5f9ea0", color: "white" }}
          onClick={() => handleAddQuestion(formType)}
        >
          <i className="bi bi-plus-lg me-1"></i> Add Question
        </button>
      </div>
      {questions.length > 0 ? (
        questions.map((item, index) => (
          <Row key={item.componentId || index} className="mb-3 p-2 border rounded bg-light">
            <Col xs={12} md={1} lg={1} className="d-flex align-items-center justify-content-center">
              <span className="fw-bold text-muted">{item.serialNo || index + 1}</span>
            </Col>
            <Col xs={12} md={4} lg={4}>
              <InputField
                className="inputBox"
                label="Question Label"
                name={`label_${formType}_${index}`}
                value={item.question?.label || ""}
                onChange={(e) => handleQuestionChange(formType, index, "label", e.target.value)}
                placeholder="Enter question text"
              />
            </Col>
            <Col xs={12} md={3} lg={3}>
              <label className="form-label" style={{ fontSize: "13px" }}>Answer Type</label>
              <select
                className="form-select form-select-sm"
                value={item.answerDefinition?.type || "text"}
                onChange={(e) => handleQuestionChange(formType, index, "type", e.target.value)}
              >
                {questionTypeOptions.map((opt) => (
                  <option key={opt.id} value={opt.name}>{opt.name}</option>
                ))}
              </select>
            </Col>
            <Col xs={12} md={2} lg={2} className="d-flex align-items-end pb-1">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id={`mandatory_${formType}_${index}`}
                  checked={item.mandatory || false}
                  onChange={(e) => handleQuestionChange(formType, index, "mandatory", e.target.checked)}
                />
                <label className="form-check-label" htmlFor={`mandatory_${formType}_${index}`} style={{ fontSize: "13px" }}>
                  Mandatory
                </label>
              </div>
            </Col>
            <Col xs={12} md={2} lg={2} className="d-flex align-items-end justify-content-end pb-1">
              <button
                className="btn btn-danger btn-sm"
                onClick={() => handleRemoveQuestion(formType, index)}
              >
                <i className="bi bi-trash3"></i>
              </button>
            </Col>
          </Row>
        ))
      ) : (
        <div className="text-center py-3">
          <p className="text-muted">
            No questions yet. Click "Add Question" to add questions for this round.
          </p>
        </div>
      )}
    </div>
  );

  // Accordion visibility states (same convention as CommercialEvaluationDetails.js:
  // true = expanded/"visible")
  const [isCardVisible0, setCardVisible0] = useState(true); // Previous Round Comparison
  const [isCardVisibleLI, setCardVisibleLI] = useState(true); // Line Items - Counter Offer
  const [isCardVisible1, setCardVisible1] = useState(true); // RFQ Type
  const [isCardVisible2, setCardVisible2] = useState(true); // Suppliers
  const [isCardVisible3, setCardVisible3] = useState(true); // Commercial Questionnaire
  const [isCardVisible4, setCardVisible4] = useState(true); // Technical Questionnaire
  const [isCardVisible5, setCardVisible5] = useState(true); // Timelines

  const toggleCardVisibility0 = () => setCardVisible0(!isCardVisible0);
  const toggleCardVisibilityLI = () => setCardVisibleLI(!isCardVisibleLI);
  const toggleCardVisibility1 = () => setCardVisible1(!isCardVisible1);
  const toggleCardVisibility2 = () => setCardVisible2(!isCardVisible2);
  const toggleCardVisibility3 = () => setCardVisible3(!isCardVisible3);
  const toggleCardVisibility4 = () => setCardVisible4(!isCardVisible4);
  const toggleCardVisibility5 = () => setCardVisible5(!isCardVisible5);

  useEffect(() => {
    if (show) {
      loadDropdownData();
      setSuppliers(supplierList || []);
      loadPreviousRoundComparison();
      loadPreviousVersionQuestionnaires();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, supplierList, currentRoundNo]);

  const loadPreviousRoundComparison = async () => {
    if (!rfxNr) return;
    setLoadingComparison(true);
    try {
      let obj = {
        data: {
          rfxNr: rfxNr, // same RFQ number across all versions
          roundNo: currentRoundNo || 1, // the round/version we are advancing FROM
        },
      };
      let res = await ItemService.getRoundComparison(obj);
      if (res?.status === 200) {
        setPreviousRoundQuotes(res?.data || []);
      } else {
        setPreviousRoundQuotes([]);
      }
    } catch (error) {
      console.log("Error loading previous round comparison", error);
      setPreviousRoundQuotes([]);
    } finally {
      setLoadingComparison(false);
    }
  };

  const loadPreviousVersionQuestionnaires = async () => {
    if (!rfxNr) return;
    try {
      let obj = {
        documentNumber: rfxNr,
      };
      let res = await ItemService.getRfxDocumentDetail(obj);
      if (res?.status === 200 && res?.data) {
        setFormCOMM(res?.data?.formCOMM || []);
        setFormTECH(res?.data?.formTECH || []);

        // Line items to show with editable counter offer
        const items = (res?.data?.items || []).map((it, idx) => ({
          ...it,
          local_id: it.local_id || idx + 1,
        }));
        setLineItems(items);

        // Also pre-fill RFQ Type from previous version if available
        if (res?.data?.rfxType && !formInputs.rfxType) {
          setFormInputs((prev) => ({ ...prev, rfxType: res.data.rfxType }));
        }
      }
    } catch (error) {
      console.log("Error loading previous version questionnaires", error);
    }
  };

  const comparisonColumns = [
    {
      name: "Supplier ID",
      selector: (row) => row.vendorCode || row.qtnSubmittedID || "--",
      sortable: true,
      width: "130px",
    },
    {
      name: "Supplier Name",
      selector: (row) => row.quotationSubmittedBy || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Quotation Nr",
      selector: (row) => row.quotationNr || "--",
      sortable: true,
      width: "140px",
    },
    {
      name: "Previous Round Total",
      selector: (row) => row.qtnTotal || "--",
      sortable: true,
      width: "160px",
    },
    {
      name: "Currency",
      selector: (row) => row.qtnBidderCurrencyCode || "--",
      sortable: true,
      width: "100px",
    },
  ];

  const handleCounterOfferChange = (localId, value) => {
    setLineItems((prev) =>
      prev.map((it) =>
        it.local_id === localId ? { ...it, counterOffer: value } : it
      )
    );
  };

  const lineItemColumns = [
    {
      name: "Document Item Nr",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "140px",
    },
    {
      name: "Material/Service",
      cell: (row) => (
        <div>
          <p className="m-0 p-0">{row.materialCode || "--"}</p>
          <p className="m-0 p-0 text-muted" style={{ fontSize: "12px" }}>
            {row.materialDescription || ""}
          </p>
        </div>
      ),
      sortable: true,
      width: "220px",
    },
    {
      name: "Quantity",
      selector: (row) => row.purchaseQuantity || "--",
      sortable: true,
      width: "110px",
    },
    {
      name: "UOM",
      selector: (row) => row.orderUnitOfMeasure || "--",
      width: "100px",
    },
    {
      name: "Counter Offer",
      cell: (row) => (
        <input
          type="number"
          className="form-control form-control-sm mt-1 mb-1"
          id={`counterOffer_${row.local_id}`}
          name="counterOffer"
          placeholder="Enter counter offer"
          value={row.counterOffer ?? ""}
          onChange={(e) => handleCounterOfferChange(row.local_id, e.target.value)}
          style={{
            color: "#3b82f6",
            fontWeight: 600,
            borderColor: "#3b82f6",
          }}
          min={0}
          onWheel={(e) => e.target.blur()}
        />
      ),
      width: "200px",
    },
  ];

  const loadDropdownData = async () => {
    try {
      let obj = {
        codeType: "RFxType",
      };
      await ItemService.getMasterData(obj).then((item) => {
        if (item?.status === 200) {
          setRFxType(item?.data || []);
        } else {
          setRFxType([]);
          console.log(">> Error: Loading RFxType");
        }
      });
    } catch (error) {
      console.log("Error loading dropdown data", error);
    }
  };

  const removeSupplierRow = (AssociateNumber) => {
    setSuppliers((prev) =>
      prev.filter((program) => program.AssociateNumber !== AssociateNumber)
    );
    toast.success("Supplier removed successfully", {
      duration: 2000,
      position: "top-right",
    });
  };

  const suppliersColumns = [
    {
      name: "Delete",
      selector: (row) => row.AssociateNumber || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btn btn-danger btn-sm"
          onClick={() => removeSupplierRow(row.AssociateNumber)}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "80px",
    },
    {
      name: "Supplier ID",
      selector: (row) => row.AssociateNumber || "--",
      sortable: true,
      cell: (row) => (
        <button className="btnInfo">{row.AssociateNumber || "-"}</button>
      ),
      width: "120px",
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => <TableStatusField status={row.status} />,
      width: "150px",
    },
    {
      name: "Supplier Name",
      selector: (row) => row.organisationName,
      sortable: true,
      width: "180px",
    },
    {
      name: "SAP Number",
      selector: (row) => row.sapAssociateNumber || "--",
      sortable: true,
      width: "130px",
    },
    {
      name: "Contact Person",
      selector: (row) => row.contactfirstName || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Contact Number",
      selector: (row) => row.contactNumber || "--",
      sortable: true,
      width: "130px",
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      width: "200px",
    },
  ];

  const onInputChangeopeningDate = ({ target: { name, value } }) => {
    setOpenCloseInput((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    if (
      getOpenCloseInput.openingDate !== "" ||
      getOpenCloseInput.openingTime !== "" ||
      getOpenCloseInput.closingDate !== "" ||
      getOpenCloseInput.closingTime !== ""
    ) {
      let openDate =
        getOpenCloseInput.openingDate + " " + getOpenCloseInput.openingTime;
      let closeDate =
        getOpenCloseInput.closingDate + " " + getOpenCloseInput.closingTime;
      let res = checkTimeDifference(openDate, closeDate);
      getOpenCloseInput.status = res.status;
      getOpenCloseInput.msg = res.msg + " '(Opening and Closing Fields)' !!";

      if (getOpenCloseInput.closingDate !== "") {
        if (res.status) {
          getOpenCloseInput.totalHour = res.totalHours;
        } else {
          toast.error(res.msg, {
            duration: 4000,
            position: "top-right",
          });
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getOpenCloseInput]);

  const handleAddSupplier = (e) => {
    e && e.stopPropagation();
    setSupplierModalShow(true);
  };

  const handleInitiateSupplierRequest = (e) => {
    e && e.stopPropagation();
    toast.success("Supplier Request initiated", {
      duration: 2000,
      position: "top-right",
    });
  };

  const handleSelectedRows = (selectedRows) => {
    setSelectedSuppliers(selectedRows);
  };

  const handlePassDataToParent = (data) => {
    setSuppliers((prevData) => {
      const updatedData = [
        ...prevData,
        ...data.filter(
          (newObj) =>
            !prevData.some(
              (existingObj) =>
                existingObj.AssociateNumber === newObj.AssociateNumber
            )
        ),
      ];
      return updatedData;
    });
  };

  const handleCreateRound = async () => {
    if (!formInputs.rfxType) {
      toast.error("Please select RFQ Type");
      return;
    }
    if (!getOpenCloseInput.openingDate) {
      toast.error("Please select Opening Date");
      return;
    }
    if (!getOpenCloseInput.openingTime) {
      toast.error("Please select Opening Time");
      return;
    }
    if (!getOpenCloseInput.closingDate) {
      toast.error("Please select Closing Date");
      return;
    }
    if (!getOpenCloseInput.closingTime) {
      toast.error("Please select Closing Time");
      return;
    }

    // Same rfxNr — backend inserts this as the NEXT VERSION (V0 -> V1 -> ...)
    // of this RFQ. The old version stays untouched as history.
    const roundData = {
      rfxNr: rfxNr,
      rfxType: formInputs.rfxType,
      openingDate: getOpenCloseInput.openingDate,
      openingTime: getOpenCloseInput.openingTime,
      closingDate: getOpenCloseInput.closingDate,
      closingTime: getOpenCloseInput.closingTime,
      supplierList: suppliers,
      formCOMM: formCOMM,
      formTECH: formTECH,
      // Line items with buyer entered counter offer (shown to suppliers in blue)
      items: lineItems,
    };

    setIsSubmitting(true);
    try {
      let res = await ItemService.createRound({ data: roundData });
      if (res?.status === 200) {
        toast.success(res?.message || "New round created successfully!", {
          duration: 2000,
          position: "top-right",
        });
        onHide();
        if (onSuccess) onSuccess();
      } else {
        toast.error(res?.message || "Unable to create round", {
          duration: 3000,
          position: "top-right",
        });
      }
    } catch (error) {
      console.log("Error creating round", error);
      toast.error("Unable to create round", {
        duration: 3000,
        position: "top-right",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="xl" centered dialogClassName="modal-70w">
      <Modal.Header closeButton>
        <Modal.Title>
          Create Round | <span style={{ fontWeight: 400 }}>{rfxNr}</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          className="alert alert-info d-flex align-items-center mb-3"
          role="alert"
          style={{ fontSize: "13px" }}
        >
          <i className="bi bi-info-circle me-2"></i>
          You are creating the next version of this RFQ ({rfxNr}). Suppliers from
          the current version are pre-selected and will need to acknowledge and
          submit a fresh quotation. You can add new suppliers, change the
          evaluation template and define new timelines for this version.
        </div>

        {/* Previous Round Quotation Comparison */}
        <div className="accordion mb-4">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible0 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility0}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">PC</span>
                </Col>
                <Col xs={12} md={9} lg={9}>
                  <span className="headerTitle">
                    Previous Round Quotation Comparison
                  </span>
                  <span className="subHeaderTitle">
                    Prices submitted in the current version
                  </span>
                </Col>
              </Row>
            </h2>
            <div
              className={`accordion-collapse collapse show ${
                isCardVisible0 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <DataTable
                      columns={comparisonColumns}
                      data={previousRoundQuotes}
                      progressPending={loadingComparison}
                      noDataComponent="No quotations found for the current version of this RFQ"
                      dense
                      persistTableHead
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>

        {/* 1. RFQ Type */}
        <div className="accordion mb-4">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible1 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility1}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">RT</span>
                </Col>
                <Col xs={12} md={9} lg={9}>
                  <span className="headerTitle">1. RFQ Type</span>
                  <span className="subHeaderTitle">Basic Information</span>
                </Col>
              </Row>
            </h2>
            <div
              className={`accordion-collapse collapse show ${
                isCardVisible1 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row className="pt-2 pb-4">
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <ComboboxField3
                      label="RFQ Type *"
                      placeholder=""
                      data={getRFxType}
                      id="rfxType"
                      iconClassName="dropdownIcon"
                      name="rfxType"
                      code="rfxTypeCode"
                      description="rfxTypeDesc"
                      setValue={formInputs.rfxType || ""}
                      getvalue={(obj) =>
                        setFormInputs((prev) => ({ ...prev, rfxType: obj?.name || "" }))
                      }
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>

        {/* 2. Suppliers */}
        <div className="accordion mb-4">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible2 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility2}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">SD</span>
                </Col>
                <Col xs={12} md={5} lg={5}>
                  <span className="headerTitle">2. Suppliers *</span>
                  <span className="subHeaderTitle">Selected Suppliers Details</span>
                </Col>
                <Col xs={12} md={4} lg={4} className="text-end">
                  <button
                    className="btn btn-sm me-2"
                    style={{ backgroundColor: "#5f9ea0", color: "white" }}
                    onClick={handleAddSupplier}
                  >
                    Add Supplier
                  </button>
                  <button
                    className="btn btn-sm"
                    style={{ backgroundColor: "#5f9ea0", color: "white" }}
                    onClick={handleInitiateSupplierRequest}
                  >
                    Initiate Supplier Request
                  </button>
                </Col>
              </Row>
            </h2>
            <div
              className={`accordion-collapse collapse show ${
                isCardVisible2 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    {suppliers.length > 0 ? (
                      <DataTable
                        columns={suppliersColumns}
                        data={suppliers}
                        selectableRows
                        pagination
                        highlightOnHover
                      />
                    ) : (
                      <div className="text-center py-4">
                        <p className="text-muted">
                          No suppliers added yet. Click "Add Supplier" to add suppliers.
                        </p>
                      </div>
                    )}
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>

        {/* Line Items - Counter Offer */}
        <div className="accordion mb-4">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisibleLI ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibilityLI}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">LI</span>
                </Col>
                <Col xs={12} md={9} lg={9}>
                  <span className="headerTitle">Line Items | Counter Offer</span>
                  <span className="subHeaderTitle">
                    Enter the counter offer for each line item - values appear
                    in blue to suppliers when they submit their quotation
                  </span>
                </Col>
              </Row>
            </h2>
            <div
              className={`accordion-collapse collapse show ${
                isCardVisibleLI ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <DataTable
                      columns={lineItemColumns}
                      data={lineItems}
                      noDataComponent="No line items found for this RFQ"
                      dense
                      persistTableHead
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>

        {/* 3. Form: COMMERCIAL - Questionnaire */}
        <div className="accordion mb-4">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible3 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility3}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">OC</span>
                </Col>
                <Col xs={12} md={9} lg={9}>
                  <span className="headerTitle">3. Form: COMMERCIAL - Questionnaire</span>
                  <span className="subHeaderTitle">
                    {formCOMM.length > 0
                      ? `${formCOMM.length} questions`
                      : "No questions added yet"}
                  </span>
                </Col>
              </Row>
            </h2>
            <div
              className={`accordion-collapse collapse show ${
                isCardVisible3 ? "visible" : ""
              }`}
            >
              {renderQuestionnaireEditor(formCOMM, "formCOMM")}
            </div>
          </div>
        </div>

        {/* 4. Form: TECHNICAL - Questionnaire */}
        <div className="accordion mb-4">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible4 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility4}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">TS</span>
                </Col>
                <Col xs={12} md={9} lg={9}>
                  <span className="headerTitle">4. Form: TECHNICAL - Questionnaire</span>
                  <span className="subHeaderTitle">
                    {formTECH.length > 0
                      ? `${formTECH.length} questions`
                      : "No questions added yet"}
                  </span>
                </Col>
              </Row>
            </h2>
            <div
              className={`accordion-collapse collapse show ${
                isCardVisible4 ? "visible" : ""
              }`}
            >
              {renderQuestionnaireEditor(formTECH, "formTECH")}
            </div>
          </div>
        </div>

        {/* 5. Timelines (Scheduling) */}
        <div className="accordion mb-4">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible5 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility5}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">SC</span>
                </Col>
                <Col xs={12} md={9} lg={9}>
                  <span className="headerTitle">5. Timelines (Scheduling)</span>
                  <span className="subHeaderTitle">Opening and Closing Dates &amp; Times</span>
                </Col>
              </Row>
            </h2>
            <div
              className={`accordion-collapse collapse show ${
                isCardVisible5 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row className="pt-2 pb-4">
                  <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
                    <InputField
                      className="inputBox"
                      label="Opening Date *"
                      name="openingDate"
                      id="openingDate"
                      type="date"
                      placeholder=""
                      value={getOpenCloseInput.openingDate || ""}
                      onChange={onInputChangeopeningDate}
                      required={true}
                    />
                  </Col>
                  <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
                    <InputField
                      className="inputBox"
                      label="Opening Time *"
                      name="openingTime"
                      id="openingTime"
                      type="time"
                      placeholder=""
                      value={getOpenCloseInput.openingTime || ""}
                      onChange={onInputChangeopeningDate}
                      required={true}
                    />
                  </Col>
                  <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding mt-3">
                    <InputField
                      className="inputBox"
                      label="Closing Date *"
                      name="closingDate"
                      id="closingDate"
                      type="date"
                      placeholder=""
                      value={getOpenCloseInput.closingDate || ""}
                      onChange={onInputChangeopeningDate}
                      required={true}
                    />
                  </Col>
                  <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding mt-3">
                    <InputField
                      className="inputBox"
                      label="Closing Time *"
                      name="closingTime"
                      id="closingTime"
                      type="time"
                      placeholder=""
                      value={getOpenCloseInput.closingTime || ""}
                      onChange={onInputChangeopeningDate}
                      required={true}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleCreateRound}
          disabled={isSubmitting}
          style={{ backgroundColor: "#3b82f6", borderColor: "#3b82f6" }}
        >
          {isSubmitting ? "Creating..." : "Create Round"}
        </Button>
      </Modal.Footer>

      {/* CreateRFQSuppliers Modal */}
      <CreateRFQSuppliers
        show={supplierModalShow}
        onHide={() => setSupplierModalShow(false)}
        selectedSuppliers={selectedSuppliers}
        onSelectedRows={handleSelectedRows}
        passDataToParent={handlePassDataToParent}
      />
    </Modal>
  );
};

export default CreateRoundModal;